// extracted by mini-css-extract-plugin
module.exports = {"container":"MSelectList_container__kRPiS","item":"MSelectList_item__3GQBN","item--selected":"MSelectList_item--selected__2baD5"};